import * as React from "react";
import { BalanceUpdateAiAdjustmentDetailsFragmentFragment } from "../../../hooks/useTransactions/graphql/TransactionsFragment.generated";
import { Trans } from "react-i18next";

// A balance change by the AI agent looks to the player the same as an admin adjustment
export const BalanceUpdateAiAdjustmentDetails = ({
  details,
}: {
  details: BalanceUpdateAiAdjustmentDetailsFragmentFragment;
}) => {
  return (
    <Trans i18nKey="transaction.BalanceUpdateAdjustment_details">
      Balance adjustment <strong>{{ notes: details.notes }}</strong>
    </Trans>
  );
};
